import axiosInstance from "@/services/http/axios-instance";

export class PosApi {
  getOperations(merchantId, terminalId) {
    return axiosInstance.post("/report/pos", {
      merchant_id: merchantId,
      terminal_id: terminalId,
    });
  }
}
